module.exports = __webpack_public_path__ + "assets/fonts/glyphicons-halflings-regular.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.woff
 ** module id = 1091
 ** module chunks = 0
 **/